import Cookies from 'js-cookie'

/**
 * Reloads without handling any outstanding fetches.
 *
 * @returns A never-resolving promise.
 */
function doBlockingReload() {
  window.location.reload()
  return new Promise<never>(() => {})
}

export default defineNuxtRouteMiddleware(to => {
  const { $sentry } = useNuxtApp()

  const abCookieValue = Cookies.get('nf_ab')

  if (abCookieValue) {
    $sentry.setTag('ab_value', abCookieValue)
  }

  const { splitTesting } = useRuntimeConfig().public

  if (!splitTesting.branch) return

  const { id: userId, attributes: userAttributes } = storeToRefs(useUserStore())

  const routeName = (to.name as string) ?? ''

  if (userId.value && userAttributes.value.frontendVersion === splitTesting.branch) {
    // Don't set the cookie again if unchanged
    if (abCookieValue === splitTesting.branch) return

    const date = new Date()
    const expires = date.getTime() + 1000 * 3600 * 24 * 365
    date.setTime(expires)

    Cookies.set('nf_ab', splitTesting.branch, { expires: date })

    return doBlockingReload()
  } else if (userId.value && abCookieValue === splitTesting.branch) {
    // We don't want to interrupt with a reload on auth routes, that will happen on next login if necessary
    if (['login', 'logout'].includes(routeName)) return

    // Reset to default branch
    Cookies.remove('nf_ab')

    return doBlockingReload()
  }
})
